export default "__VITE_ASSET__Bdd6yXU4__"